import { render, staticRenderFns } from "./institutional-index.vue?vue&type=template&id=1000f074&scoped=true"
import script from "./institutional-index.vue?vue&type=script&lang=js"
export * from "./institutional-index.vue?vue&type=script&lang=js"
import style0 from "./institutional-index.vue?vue&type=style&index=0&id=1000f074&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1000f074",
  null
  
)

export default component.exports